<template>
  <AppHead :title="`${props.site.event_name} - Checkout`"></AppHead>
  <slot />
</template>

<script setup>
import AppHead from '../Components/AppHead.vue'
import { usePage } from '@inertiajs/vue3'

const { props } = usePage()
</script>
